import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import './MeetingDetailPage.scss'
import CommentList from '../../Components/Commons/CommentList'
import ReadList from '../../Components/Commons/ReadList'
// import $ from 'jquery'
// import jQuery from 'jquery'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
// import ImageZoom from 'react-medium-image-zoom'
// import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
    RoleStr,
    renderFiles,
    renderPDFFiles,
    renderImageFiles,
    renderOfficeFiles,
    renderVideoFiles,
} from '../../Components/Commons/Utils'

class MeetingDetailPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            meeting: null,
            user: null,
            deletePop: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
        this.loadData()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
                console.log(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadData = () => {
        axios
            .get(`${BACKEND_HOST}/postings/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ meeting: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteData = () => {
        axios
            .delete(`${BACKEND_HOST}/postings/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({
                    deletePop: false,
                })
                window.location.href = '/meeting'
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        if (this.state.meeting) {
            //날짜 변환
            const newDate = new Date(this.state.meeting.createdAt)
            const newYear = newDate.getFullYear()
            const week = new Array('일', '월', '화', '수', '목', '금', '토')
            const newDayName = week[newDate.getDay()]

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }

            const codes = this.state.meeting.content

            let user = {
                role: '역할',
                name: '이름',
            }
            if (
                this.state.meeting.writer &&
                this.state.meeting.writer !== '' &&
                this.state.meeting.writer !== undefined
            ) {
                user.role = RoleStr[this.state.meeting.writer.group]
                user.name = this.state.meeting.writer.name
            } else if (this.state.meeting.user && this.state.meeting.user.name) {
                user.role = '협력사'
                user.name = this.state.meeting.user.name
            }

            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="meeting_detail_wrap common_detail">
                            <div className="section">
                                <div className="top_wrap">
                                    <div className="page_name">회의록</div>
                                    <h1>{this.state.meeting.title}</h1>
                                    <ul>
                                        <li>
                                            <p className="title">작성일</p>
                                            <p className="content">
                                                {newYear}.{newMonth}.{newDay} ({newDayName})
                                            </p>
                                        </li>
                                        <li>
                                            <p className="title">작성자</p>
                                            <p className="content">
                                                {user.role} {user.name}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                {this.state.meeting.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderFiles(this.state.meeting.files)}</div>
                                    </div>
                                )}
                                {this.state.meeting.files.length !== 0 && renderPDFFiles(this.state.meeting.files)}
                                {this.state.meeting.files.length !== 0 && renderOfficeFiles(this.state.meeting.files)}
                                {this.state.meeting.files.length !== 0 && renderImageFiles(this.state.meeting.files)}
                                {this.state.meeting.files.length !== 0 && renderVideoFiles(this.state.meeting.files)}
                                <div className="meeting_content">
                                    <div className="inner_html" dangerouslySetInnerHTML={{ __html: codes }}></div>
                                </div>
                                {this.state.user &&
                                    this.state.meeting &&
                                    this.state.user._id === this.state.meeting.writer._id && (
                                        <ul className="btn_wrap">
                                            <li
                                                className="gray_btn_s"
                                                onClick={() => this.setState({ deletePop: true })}>
                                                삭제
                                            </li>
                                            <Link to={`/meeting/write/${this.state.meeting._id}`}>
                                                <li className="green_btn_s">수정</li>
                                            </Link>
                                        </ul>
                                    )}

                                {this.state.deletePop && (
                                    <div className="alret_pop2_bg">
                                        <div className="alret_pop2_wrap">
                                            <p className="h1_text">삭제하시겠습니까?</p>
                                            <p>삭제하면 복원할 수 없습니다.</p>
                                            <div
                                                className="btn btn1"
                                                onClick={() => this.setState({ deletePop: false })}>
                                                아니오
                                            </div>
                                            <div className="btn btn2" onClick={() => this.deleteData()}>
                                                네
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <ReadList readers={this.state.meeting.readUsers} />

                                <div className={'comment_show'}>
                                    <CommentList
                                        project_id={this.state.meeting._project}
                                        id={this.props.match.params.id}
                                        page={'meeting'}
                                        url={'POSTING'}
                                    />
                                </div>
                            </div>

                            <Link to={`/meeting/`}>
                                <div className="list_btn common_wrap">
                                    목록
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#6D7075"
                                            strokeLinecap="round"
                                            strokeWidth="1.2">
                                            <path d="M.674 1H9.32M.674 4.06h6.277M.674 7.06h8.65" />
                                        </g>
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap"></div>
            </div>
        )
    }
}

export default withCookies(MeetingDetailPage)



// WEBPACK FOOTER //
// ./Src/Containers/Meeting/MeetingDetailPage.js